<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Guide d'accessibilit&eacute;">
     Guide d'accessibilit&eacute;
    </a>
   </p>
   <p class="toc-1-style">
    <a href="accessibility-guide-overview-chapter.html#accessibility-guide-overview-chapter_fr" title="Aper&ccedil;u">
     Aper&ccedil;u
    </a>
   </p>
   <div id="divd0e13">
    <p class="toc-2-style">
     <a href="supported-models-accessibility-topic.html#supported-models-accessibility_fr" title="Mod&egrave;les d'imprimante pris en charge">
      Mod&egrave;les d'imprimante pris en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessible-version-users-guide-topic.html#accessible-version-users-guide_fr" title="Recherche de la version HTML accessible du Guide de l'utilisateur">
      Recherche de la version HTML accessible du
      <span class="document-title-style">
       Guide de l'utilisateur
      </span>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fr" title="Contacter l'assistance client&egrave;le">
      Contacter l'assistance client&egrave;le
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-printer-accessibility-topic.html#locating-printer-accessibility_fr" title="Emplacement de l'imprimante en vue de son accessibilit&eacute;">
      Emplacement de l'imprimante en vue de son accessibilit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_fr" title="A partir du panneau de commandes">
      A partir du panneau de commandes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-quick-copy-using-control-panel-topic.html#making-quick-copy-using-control-panel_fr" title="Effectuer une copie rapide &agrave; l'aide du panneau de commandes">
      Effectuer une copie rapide &agrave; l'aide du panneau de commandes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="enabling-user-selectable-accessibility-features-chapter.html#enabling-user-selectable-accessibility-features-chapter_fr" title="Activation des fonctions d'accessibilit&eacute; choisies par l'utilisateur">
     Activation des fonctions d'accessibilit&eacute; choisies par l'utilisateur
    </a>
   </p>
   <div id="divd0e234">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_fr" title="Activation du mode Agrandissement">
      Activation du mode Agrandissement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e259" title="Utilisation de l'assistance vocale Lexmark">
      Utilisation de l'assistance vocale Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-keyboard-topic.html#d0e405" title="Utilisation du clavier">
      Utilisation du clavier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="performing-task-using-keyboard-group.html#d0e558" title="Ex&eacute;cution d'une t&acirc;che &agrave; l'aide du clavier">
      Ex&eacute;cution d'une t&acirc;che &agrave; l'aide du clavier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="overview-topic.html#d0e635" title="Configuration et utilisation de Lexmark Accessibility Solution">
      Configuration et utilisation de Lexmark Accessibility Solution
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="configuring-accessibility-features-chapter.html#configuring-accessibility-features-chapter_fr" title="Configuration des param&egrave;tres d'accessibilit&eacute;">
     Configuration des param&egrave;tres d'accessibilit&eacute;
    </a>
   </p>
   <div id="divd0e716">
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_fr" title="R&eacute;glage du d&eacute;bit de parole de l'assistance vocale">
      R&eacute;glage du d&eacute;bit de parole de l'assistance vocale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_fr" title="R&eacute;glage du volume par d&eacute;faut du casque">
      R&eacute;glage du volume par d&eacute;faut du casque
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#adjusting-default-internal-speaker-volume_fr" title="R&eacute;glage du volume par d&eacute;faut du haut-parleur interne">
      R&eacute;glage du volume par d&eacute;faut du haut-parleur interne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_fr" title="Activation des codes PIN (num&eacute;ros d'identification personnels) ou des mots de passe &eacute;nonc&eacute;s">
      Activation des codes PIN (num&eacute;ros d'identification personnels) ou des mots de passe &eacute;nonc&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-keyboard-type-topic.html#changing-keyboard-type_fr" title="Modification du type de clavier">
      Modification du type de clavier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-fax-speaker-settings-topic.html#configuring-fax-speaker-settings_fr" title="Configuration des param&egrave;tres du haut-parleur du t&eacute;l&eacute;copieur">
      Configuration des param&egrave;tres du haut-parleur du t&eacute;l&eacute;copieur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-audible-alert-when-loading-paper-into-adf-tray-topic.html#enabling-audible-alert-when-loading-paper-into-adf-tray_fr" title="Activation d'une alerte sonore lors du chargement du papier dans le tiroir DAA">
      Activation d'une alerte sonore lors du chargement du papier dans le tiroir DAA
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-output-bin-lighting-topic.html#enabling-output-bin-lighting_fr" title="Activation de l'&eacute;clairage du r&eacute;ceptacle">
      Activation de l'&eacute;clairage du r&eacute;ceptacle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-key-repeat-rate-topic.html#adjusting-key-repeat-rate_fr" title="R&eacute;glage de la fr&eacute;quence de r&eacute;p&eacute;tition">
      R&eacute;glage de la fr&eacute;quence de r&eacute;p&eacute;tition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-initial-delay-before-key-repeat-topic.html#adjusting-initial-delay-before-key-repeat_fr" title="R&eacute;glage du d&eacute;lai avant r&eacute;p&eacute;tition">
      R&eacute;glage du d&eacute;lai avant r&eacute;p&eacute;tition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-duplicate-key-strike-interval-topic.html#adjusting-duplicate-key-strike-interval_fr" title="R&eacute;glage de l'intervalle de double frappe">
      R&eacute;glage de l'intervalle de double frappe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-two-sided-copying-topic.html#enabling-two-sided-copying_fr" title="Activation de la copie recto verso">
      Activation de la copie recto verso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-optical-character-recognition-based-scans-topic.html#configuring-optical-character-recognition-based-scans_fr" title="Configuration de la num&eacute;risation avec reconnaissance optique des caract&egrave;res">
      Configuration de la num&eacute;risation avec reconnaissance optique des caract&egrave;res
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-display-language-topic.html#changing-display-language_fr" title="Modification de la langue d'affichage">
      Modification de la langue d'affichage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="extending-inactivity-timeout-topic.html#extending-inactivity-timeout_fr" title="Extension du d&eacute;lai d'inactivit&eacute;">
      Extension du d&eacute;lai d'inactivit&eacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fr" title="Avis">
     Avis
    </a>
   </p>
   <div id="divd0e1115">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights_fr" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fr" title="Marques commerciales">
      Marques commerciales
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue